var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_vm._v(" Saliendo, porfavor espere... "),_c('br'),_c('v-progress-circular',{attrs:{"indeterminate":"","x-large":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }